module.exports = "/_next/static/images/lunchset-b54cf703d5569b782e95b1380ab76dce.jpg";